import * as React from "react";
const SvgFiRrGamepad = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M22.208 5.029c-.897-1.494-2.49-2.49-4.283-2.49H5.975c-1.792 0-3.386.996-4.282 2.49C.598 7.02 0 9.21 0 11.502c0 5.477 2.19 9.958 4.98 9.958 1.493 0 2.688-1.394 3.584-4.282.1-.398.498-.697.996-.697h4.88c.398 0 .797.299.996.697.896 2.888 2.091 4.282 3.585 4.282 2.788 0 4.979-4.481 4.979-9.958-.1-2.29-.697-4.482-1.793-6.473m-3.287 14.44c-.299 0-.996-.797-1.693-2.888-.398-1.295-1.593-2.092-2.888-2.092H9.56c-1.294 0-2.49.896-2.888 2.092-.697 2.09-1.394 2.887-1.693 2.887-.996 0-2.987-3.087-2.987-7.966 0-1.892.498-3.784 1.394-5.477.597-.897 1.593-1.494 2.59-1.494h11.95c.995 0 1.991.597 2.589 1.494.896 1.693 1.394 3.585 1.394 5.477 0 4.88-1.992 7.966-2.988 7.966"
    />
    <path
      fill="#062147"
      d="M9 9H8V8c0-.6-.4-1-1-1s-1 .4-1 1v1H5c-.6 0-1 .4-1 1s.4 1 1 1h1v1c0 .6.4 1 1 1s1-.4 1-1v-1h1c.6 0 1-.4 1-1s-.4-1-1-1M18.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M15.5 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    />
  </svg>
);
export default SvgFiRrGamepad;
